module.exports = __webpack_public_path__ + "assets/img/f374-sx.svg";